import React from 'react'
import programCss from './program-css'
import NavBar from '../../components/nav-bar/nav-bar'
import Footer from '../../components/footer/footer'
import PageTitle from '../../components/page-title/page-title'
import Section from '../../components/section/section'

type timelinePoint = {
  name: string;
  time?: string;
  description: string;
  icon?: string;
  visible: boolean;
};

const TIMELINE_MAP: Record<string, timelinePoint> = {
  "point1": {
    name: "Příjezd hostů",
    time: "10 : 00",
    description: "Parkování najdete přímo v resortu. Prosíme, naplánujte si cestu tak, abyste dorazili ještě před obřadem. Drobné občerstvení bude připraveno v restauraci.",
    icon: "assets/car.png",
    visible: true,
  },
  "point2": {
    name: "Přípravy",
    time: "10 : 30",
    description: "Na scénu nastupuje naše koordinátorka – rozdá kytice, připne korsáže/myrty a sdělí vám vše důležité. Pokud budete tápat, je vaší mapou, kompasem i záchranným lanem v jednom.",
    icon: "assets/flower.png",
    visible: true,
  },
  "point3": {
    name: "Obřad",
    time: "11 : 00",
    description: "Prosíme, při obřadu nevytahujte telefony. Máme úžasného kameramana a fotografku, kteří vše zdokumentují za vás. Byla by škoda, kdybychom na fotkách viděli displeje vašich telefonů.",
    icon: "assets/ceremony.png",
    visible: true,
  },
  "point4": {
    name: "Blahopřání + špalír",
    time: "11 : 15",
    description: "Po obřadu proběhnou gratulace, poté hosté vytvoří slavnostní špalír a budou se házet okvětní lístky. Ve špalíru se ještě chvíli setrvá a natočí se vzpomínkové video.",
    icon: "assets/hands.png",
    visible: true,
  },
  "point5": {
    name: "Focení s rodinou",
    time: "11 : 30",
    description: "Focení bude rozděleno na dvě části. Dopoledne proběhne společná fotka, pár skupinových fotek s rodinou a nakonec několik záběrů z dronu. Odpoledne proběhne další focení.",
    icon: "assets/photo.png",
    visible: true,
  },
  "point6": {
    name: "Přípitek + svatební tradice",
    time: "11 : 45",
    description: "Zvedneme skleničky a přidáme pár klasických tradic. Nějaký ten střep pro štěstí, přenesení přes práh... prostě svatba, jak má být se špetkou folklóru.",
    icon: "assets/cheers.png",
    visible: true,
  },
  "point7": {
    name: "Oběd",
    time: "12 : 00",
    description: "V poledne se přesuneme do vigvamu, kde už bude připravená svatební tabule. Těšit se můžete na dvouchodové svatební menu, které potěší oko i bříško.",
    icon: "assets/lunch.png",
    visible: true,
  },
  "point8": {
    name: "Volná zábava",
    description: "Tento čas můžete využít dle libosti! K dispozici bude fotokoutek s neomezeným počtem výtisků a zábavnými rekvizitami. Fotku si můžete ponechat nebo ji vložit do svatební knihy. Dále bude připravená schránka na vzkazy/rady do manželství pro novopečené manžele. Tyto vzkazy si novomanželé přečtou za rok a zavzpomínají tak na tento výjímečný den. Nebo si můžete přečíst dopis od novomanželů pro vás.",
    visible: true,
  },
  "point9": {
    name: "Krájení dortu",
    time: "14 : 30",
    description: "Přichází sladká chvíle – rozkrájíme svatební dort. Porce budou degustační. Pro další dávku cukru můžete navštívit sweet bar, kde najdete další skvělé dezerty.",
    icon: "assets/cake.png",
    visible: true,
  },
  "point10": {
    name: "První novomanželský tanec",
    time: "15 : 00",
    description: "První tanec novomanželů bude probíhat uvnitř vigvamu. Tady vás buď dojmeme, okouzlíme, nebo rozesmějeme.",
    icon: "assets/dance.png",
    visible: true,
  },
  "point11": {
    name: "Hra - Svatební kvíz",
    time: "15 : 30",
    description: "Znáte novomanžele? Tradiční svatební hra, při které padají záludné otázky, zvedají se boty a dochází k pár odhalení z jejich společného života.",
    icon: "assets/game.png",
    visible: true,
  },
  "point12": {
    name: "Focení s novomanželi",
    time: "16 : 00",
    description: "Chcete fotku s novomanželi? Je připravené další focení, kterého se může zúčastnit kdokoli. Nenechte si ujít tuto příležitost.",
    icon: "assets/photo.png",
    visible: true,
  },
  "point13": {
    name: "'Házení' kytice",
    time: "16 : 30",
    description: "Kytice se házet nebude – bude se stříhat! Každá svobodná žena dostane stuhu, ale jen jedna získá tu pravou. A nebojte, na pány taky něco čeká.",
    icon: "assets/flower.png",
    visible: true,
  },
  "point14": {
    name: "Studený raut",
    time: "17 : 00",
    description: "Čas na malé občerstvení – studené mísy, chuťovky k vínu či pivu. Ideální mezihra před večerním grilováním. Raut bude připraven uvnitř vigvamu.",
    icon: "assets/meal.png",
    visible: true,
  },
  "point15": {
    name: "Hra - Rok s novomanželi",
    time: "18 : 00",
    description: "Další hra, 13 dobrovolníků, 12 měsíců a pořádná porce zábavy. Připravte se na bláznivé úkoly.",
    icon: "assets/game.png",
    visible: true,
  },
  "point16": {
    name: "Teplý raut",
    time: "19 : 00",
    description: "Pořádné jídlo se připraví formou grilování, které se bude konat venku za vigvamem. Ideální na letní večer.",
    icon: "assets/bbq.png",
    visible: true,
  },
  "point17": {
    name: "Svatební tombola",
    time: "19 : 30",
    description: "Jeden los pro každého – zcela zdarma a bez možností úplatků! Vyhrát můžete zájezd pro dva, soukromou zámeckou prohlídku a další hodnotné (i méně hodnotné, ale zábavné) ceny.",
    icon: "assets/ticket.png",
    visible: true,
  },
  "point18": {
    name: "Focení novomanželů při západu slunce",
    time: "20 : 00",
    description: "Novomanželé na chvíli zmizí za romantikou a objektivem – ideální kulisa pro kouzelné záběry při zlaté hodině.",
    icon: "assets/photo.png",
    visible: true,
  },
  "point19": {
    name: "Tanec/špalír s prskavkami",
    time: "20 : 30",
    description: "Večer se rozsvítí prskavky, vytvoříme světelný špalír nebo kruh a uděláme pár kouzelných fotek. Po setmění to bude mít tu správnou atmosféru.",
    icon: "assets/sparkler.png",
    visible: true,
  },
  "point20": {
    name: "Party začíná",
    time: "21 : 00",
    description: "DJ spustí hudbu, světýlka se rozsvítí, náramky zazáří a začne pravá svatební jízda.",
    icon: "assets/music.png",
    visible: true,
  },
}

const ProgramView: React.FC = () => {
  return (
    <>
      <NavBar />
      <PageTitle marginTop>Co máme v plánu během dne?</PageTitle>

      <div className={programCss.info()}>
          Časy v harmonogramu od obřadu jsou pouze orientační.
          <br />
          Může se stát, že některé věci budou trvat déle jiné krátce. Také bude záležet na počasí.
      </div>

      <Section>
        <div className={programCss.timeline()}>
          {Object.keys(TIMELINE_MAP).map((it) => {
            return (
              <div key={it} className={programCss.timelineItem()}>
                <div className={programCss.time(TIMELINE_MAP[it].visible)}>{TIMELINE_MAP[it].time}</div>
                {TIMELINE_MAP[it].icon ? <img src={TIMELINE_MAP[it].icon} alt="icon" className={programCss.icon()} /> : <div className={programCss.icon()}> </div>}
                <div>
                  <p className={programCss.name(TIMELINE_MAP[it].visible)}>{TIMELINE_MAP[it].name}</p>
                  <p className={programCss.description(TIMELINE_MAP[it].visible)}>{TIMELINE_MAP[it].description}</p>
                </div>
              </div>
            )
          })}
        </div>
      </Section>
      <Footer />
    </>
  )
}

export default ProgramView
